
if (!customElements.get('product-parts-data')) {

  class ProductPartData extends HTMLElement {
    parts = [];
    objectMap = {}
    dataLoaded = false
    constructor() {
      super();
      var elChilds = this.getElementsByTagName("product-part-value");
      for (let index = 0; index < elChilds.length; index++) {
        this.readPartdata(elChilds[index]);
      }
      this.dataLoaded = true;
      this.dispatchEvent(new Event("dataLoaded"))

    }
    getPartValue(shopifyID) {
      return this.objectMap[shopifyID];
    }
    readPartdata(el) {
      var data = {
        button_image: el.dataset.button_image,
        display_name: el.dataset.display_name,
        name: el.dataset.name,
        order: el.dataset.order ? parseInt(el.dataset.order) : 0,
        shopifyId: el.dataset.shopifyId,
        values: []
      }
      var elChilds = el.getElementsByTagName("data-item");
      for (let index = 0; index < elChilds.length; index++) {
        data.values.push(this.readProdcutValue(elChilds[index]));
      }
      console.log("ProductPartData", data);
      return data;
    }

    readProdcutValue(el) {
      // console.log("readProdcutValue", el.dataset);
      var data = {
        shopifyId: el.dataset.shopifyId,
        view1: el.dataset.view1,
        view2: el.dataset.view2,
        view3: el.dataset.view3,
        order: el.dataset.order ? parseInt(el.dataset.order) : 0,
        // display_name: el.data,
        haslen: el.dataset.lenid != undefined,
        lenChart: el.dataset.lenChart,
        lenid: el.dataset.lenid,
        lenDisplayName: el.dataset.lenDisplayname,
        lenCode: el.dataset.lenCode,
        lenColor: el.dataset.lenColor,
        lenContrast: el.dataset.lenContrast,
        lenLens_category: el.dataset.lenLens_category,
        lenLens_type: el.dataset.lenLens_type,
        lenMaterial: el.dataset.lenMaterial,
        lenMirror_tint: el.dataset.lenMirror_tint,
        lenName: el.dataset.lenName,
        lenPolarized: el.dataset.lenPolarized,
        lenStock: el.dataset.lenStock,
        lenVlt_percentage: el.dataset.lenVlt_percentage,
        lenXviz: el.dataset.lenXviz,
        partvalue: el.dataset.partvalue,
        len_conditions: []
      }
      this.objectMap[data.shopifyId] = data;
      var elChilds = el.getElementsByTagName("len-condition");
      for (let index = 0; index < elChilds.length; index++) {
        data.len_conditions.push(this.readLenWeatherCondition(elChilds[index]));
      }
      return data;
    }

    readLenWeatherCondition(el) {
      return { name: el.dataset.name, image: el.dataset.image }
    }

  }
  customElements.define(
    'product-parts-data',
    ProductPartData
  );

}

